import { Box, type BoxProps } from '@talos/kyoko';

interface InspectorTextProps extends BoxProps {
  children?: React.ReactNode;
}

export const InspectorText = ({
  children,
  color = 'colorTextImportant',
  fontSize = 'fontSizeMd',
  ...props
}: InspectorTextProps) => {
  return (
    <Box
      data-testid="instrument-inspector-section-field-value"
      color={color}
      fontSize={fontSize}
      maxWidth="100%"
      overflowWrap="anywhere"
      textAlign="right"
      {...props}
    >
      {children ?? '-'}
    </Box>
  );
};
